module.exports = __webpack_public_path__ + "img/collapsible-icon.1cb56617.svg";